import config from '../data/config';

export const INTERVIEW_CDN_BASE_URL = config.AWS_CDN_LINK;

// Utility function to extract fileId from old API URL
export const extractFileIdFromApiUrl = (apiUrl: string): string | null => {
    try {
      // Check if URL is already in HLS format - if so, use it directly
      if (apiUrl.includes('/streams/') && apiUrl.endsWith('.m3u8')) {
        return apiUrl; // Return as-is, don't convert
      }
      
      // Extract filename from old API URL format
      const urlParts = apiUrl.split('/');
      const filename = urlParts[urlParts.length - 1];
      // Remove .mp4, .mp3, or .m3u8 extension to get fileId
      return filename.replace(/\.(mp4|mp3|m3u8)$/, '');
    } catch (error) {
      console.error('Error extracting fileId from API URL:', error);
      return null;
    }
  };

// Utility function to build HLS CDN URL
export const buildHlsUrl = (contentType: 'video' | 'audio', fileId: string): string => {
  return `${INTERVIEW_CDN_BASE_URL}/streams/${contentType}/${fileId}/hls/${fileId}.m3u8`;
};

// Utility function to convert old API URL to new HLS URL
export const convertApiUrlToHlsUrl = (apiUrl: string, contentType: 'video' | 'audio'): string | null => {
    // Check if URL is already in HLS format
    if (apiUrl.includes('/streams/') && apiUrl.endsWith('.m3u8')) {
      return apiUrl; // Return as-is
    }
    
    // Convert old API format to HLS
    const fileId = extractFileIdFromApiUrl(apiUrl);
    if (!fileId || fileId === apiUrl) { // If fileId is same as apiUrl, it was already HLS
      return null;
    }
    return buildHlsUrl(contentType, fileId);
};

export const buildDirectUploadsUrl = (apiUrl: string, contentType: 'video' | 'audio'): string | null => {
  try {
    // Extract fileId and filename from API URL
    // API URL format: /api/v1/application/getVideo/{fileId}-{filename}
    const match = apiUrl.match(/\/(?:getVideo|getAudio)\/([^\/]+)$/);
    if (!match) return null;
    
    const fullFilename = match[1];
    const firstHyphenIndex = fullFilename.indexOf('-');
    if (firstHyphenIndex === -1) return null;
    
    const fileId = fullFilename.substring(0, firstHyphenIndex);
    const filename = fullFilename.substring(firstHyphenIndex + 1);
    
    // Ensure proper file extension
    const expectedExtension = contentType === 'video' ? '.mp4' : '.mp3';
    const finalFilename = filename.endsWith(expectedExtension) ? filename : `${filename.replace(/\.(mp4|mp3)$/, '')}${expectedExtension}`;
    
    // Build direct uploads URL
    return `${INTERVIEW_CDN_BASE_URL}/uploads/${fileId}-${finalFilename}`;
  } catch (error) {
    console.error('Error building direct uploads URL:', error);
    return null;
  }
};